"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = isEmptyAddress;

function isEmptyAddress(a) {
  return !(a && Object.keys(a).length) || Object.values(a).every(function (a) {
    return !a;
  });
}